import { sessionStorageKeys } from '~/common/storage.constants';

const COUPON_STORAGE_KEY = sessionStorageKeys.COUPON;

export function getStoredCouponCode() {
    return sessionStorage.getItem(COUPON_STORAGE_KEY);
}

export function setStoredCouponCode(couponCode: string) {
    if (!couponCode || typeof couponCode !== 'string') {
        return;
    }
    sessionStorage.setItem(COUPON_STORAGE_KEY, couponCode);
}

export function deleteStoredCouponCode() {
    sessionStorage.removeItem(COUPON_STORAGE_KEY);
}
